<template>
  <section>
    <header class="header-image ken-burn-center light" data-parallax="true"
            data-natural-height="500" data-natural-width="1920" data-bleed="0"
            data-image-src="../media/header1_sil.jpg" data-offset="0">
      <div class="container">
        <h1>SIL</h1>
        <h2>CABO SOLAR</h2>
      </div>
    </header>
    <main>
      <section class="section-base">
        <div class="container">
          <div class="row row-fit-lg">
            <div class="col-lg-12">
              <p align="justify">
                Empresa sólida e 100% nacional, desde 1974 a SIL fornece fios e cabos elétricos
                seguros e duráveis, com preço competitivo e qualidade certificada conforme as normas
                técnicas vigentes. O conjunto de ações mercadológicas, a seriedade na política de
                atuação e na relação com seus parceiros e fornecedores, com metas e diretrizes
                honestas, somadas a iniciativas como avanços tecnológicos, rigoroso controle de
                qualidade, valorização profissional e respeito ao consumidor, fazem com que a SIL
                seja reconhecida como uma das principais empresas brasileiras de seu
                segmento.<br><br>

                &nbsp;&nbsp;A companhia iniciou suas atividades nos anos 50, ainda como Elétrica
                Danúbio, atuando exclusivamente na distribuição de materiais elétricos para a
                capital e a Grande São Paulo. Em 1974, passou a atuar também na fabricação de fios e
                cabos elétricos, com uma pequena indústria no bairro do Tatuapé, logo a seguir
                transferida para o tradicional distrito industrial da Mooca, já com a marca SIL.
                <br><br>

                &nbsp;&nbsp;Apresentando um expressivo crescimento de mercado, a SIL precisou
                expandir sua produção e infraestrutura. Assim, em 2001, mudou-se para o município de
                Guarulhos (SP), instalando-se em um moderno Centro Industrial e Administrativo, que
                possui 30.000 m². Hoje a SIL tem uma posição de destaque consolidada em seu
                segmento, levando produtos de qualidade a todo o país e sendo reconhecida com
                diversas premiações, que confirmam a preferência e liderança da marca entre
                revendedores e especificadores.
              </p>
              <img :src="require('Assets/images/photo_sil1.jpg')"><br><br>
              <img :src="require('Assets/images/photo_sil2.jpg')">
            </div>
          </div>
        </div>
      </section>
      <MarcasParceiras></MarcasParceiras>
      <br><br>
    </main>
  </section>
</template>

<script>
import MarcasParceiras from 'Homepage/common/MarcasParceiras.vue';

export default {
  name: 'Sil',
  components: {
    MarcasParceiras,
  },
};
</script>

<style scoped>
header {
  height: 250px !important;
  background-image: url("../../assets/images/header1_sil.jpg");
}
header .container {
  padding-top: 50px !important;
}
header h2 {
  color: #0098da !important;
  line-height: 37px;
  text-transform: uppercase !important;
  font-weight: 700 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

</style>
